
import React, { useState, useRef } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch, useSelector } from "react-redux";
import { login } from "../../actions/auth";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" href="https://lines.ac/">
        https://lines.ac/
      </Link>{' '}{new Date().getFullYear()}
      <br></br>
      Created by{' '}
      <Link color="inherit" href="https://www.netbee.be/">
        Netbee
      </Link>{' '}
    </Typography>
  );
}

const Login = () => {


  const form = useRef();
  const checkBtn = useRef();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { isLoggedIn } = useSelector(state => state.auth);
  const { message } = useSelector(state => state.message);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
  };

  const handleSubmit = (event) => {


    event.preventDefault();
    setLoading(true);

    dispatch(login(email, password))
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        toast.error(
          `Login failed`, { autoClose: 750, position: toast.POSITION.BOTTOM_CENTER }
        );
        setLoading(false);
      });
  };

  const handleForgotPassword = (event) => {
    event.preventDefault();
    navigate("/forgot-password")
  };

  if (isLoggedIn == true) {
    console.log(isLoggedIn)
    navigate("/Booking")
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/lines.png`}
          alt="lines"
          height={300}
          className="lines"
        />

        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            value={email}
            onChange={onChangeEmail}
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={onChangePassword}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3 }}
            disabled={loading}
            onClick={handleSubmit}>

            Sign In
          </Button>

          <Grid m={1} textAlign="center">

            <Link onClick={() => { navigate('forgot-password') }} variant="body2">
              Forgot password?
            </Link>

            <br></br>

            <Link onClick={() => { navigate('create-account') }} variant="body2">
              {"Don't have an account? Sign Up"}
            </Link>

            <br></br>

            <Link onClick={() => { navigate('Booking') }} variant="body2">
              {"Continue without log in"}
            </Link>
          </Grid>



          <Typography variant="body2" color="text.secondary" align="left">
            • Registered users can sign into their account using this screen. Usage of the portal is subject to LINES Terms & Conditions.
          </Typography>
          <br></br>
          <Typography variant="body2" color="text.secondary" align="left">
            • You need to enter USERNAME/EMAIL and PASSWORD to access your account.
          </Typography>
          <br></br>
          <Typography variant="body2" color="text.secondary" align="left">
            • Before entering your login credentials, please verify that you are using a secure connection.
          </Typography>

          {loading ?
            <Box
              sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <CircularProgress />
            </Box> : <></>
          }

        </Box>
      </Box>
      <Copyright sx={{ mt: 15, mb: 4 }} />
    </Container>
  );
}

export default Login